export default __webpack_public_path__ + "static/media/Delivery.7efb2bbf.svg";